import { useEffect, useState } from 'react'

export const useMediaQuery = (query: string) => {
  const [isDesktop, setIsDesktop] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const mediaQuery = window.matchMedia(query)
    setIsDesktop(mediaQuery.matches)

    const listener = () => setIsDesktop(mediaQuery.matches)
    mediaQuery.addEventListener('change', listener)

    return () => mediaQuery.removeEventListener('change', listener)
  }, [query])

  return isDesktop
}
